import { render, staticRenderFns } from "./TouristInfoCreateForm.vue?vue&type=template&id=1cb5e1d6&"
import script from "./TouristInfoCreateForm.vue?vue&type=script&lang=js&"
export * from "./TouristInfoCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports